<script lang="ts" setup>
import { primaryColor } from '@/config/brands'

defineProps<{
  products: any[]
  activeIndex: number
}>()

const emit = defineEmits<{
  (e: 'select', item: any, index: number): void
}>()
</script>

<template>
  <div class="recharge-grid">
    <div
      v-for="(item, index) in products"
      :key="item.productId || index"
      class="recharge-item"
      :class="{ active: activeIndex === index }"
      @click="emit('select', item, index)"
    >
      <!-- 营销标签 -->
      <span v-if="item.marketingText" class="recharge-tag">
        {{ item.marketingText }}
      </span>
      <!-- 金币数量 -->
      <div class="recharge-coins">
        {{ item.coinsBuy }}<span v-if="item.coinsBonus">+{{ item.coinsBonus }}</span> coins
      </div>
      <!-- 价格 -->
      <div class="recharge-price">
        $ {{ item.price }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.recharge-grid {
  display: grid;
  grid-template-columns: 200px 200px;
  gap: 15px;
  justify-content: space-between;
}

.recharge-item {
  position: relative;
  background: #F3F5FA;
  border: 1.5px solid transparent;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.2s, background 0.2s;
  width: 200px;
  height: 70px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.recharge-item.active {
  border-color: v-bind(primaryColor);
  background: color-mix(in srgb, v-bind(primaryColor) 8%, #fff);
}
.recharge-item:hover:not(.active) {
  border-color: #e0e0e0;
}

.recharge-tag {
  position: absolute;
  top: -8px;
  left: -1px;
  background: linear-gradient(132deg, #F961BC 0%, #F74984 100%);
  color: #fff;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 100px 100px 100px 0;
  white-space: nowrap;
}

.recharge-coins {
  font-size: 15px;
  font-weight: 600;
  color: #32353A;
  margin-bottom: 4px;
}

.recharge-price {
  font-size: 13px;
  color: #9296A0;
}
</style>
